import { useQuery } from '@tanstack/react-query'

import { useGlobalState } from '@/hooks/useGlobalState'

/**
 * Read-only access to the channel's `guest_user_access` flag (PM-controlled from
 * Channel Settings; also surfaces the "Media Access" column on the CM table).
 * Wraps the shared `['sponsor', 'info']` query so all consumers reuse one fetch.
 */
export function useGuestUserAccess() {
  const { api } = useGlobalState()

  const sponsorInfoQuery = useQuery({
    queryKey: ['sponsor', 'info'],
    queryFn: () => api.getSponsorInfo(),
    staleTime: 5 * 60 * 1000,
  })

  return {
    guestUserAccess: sponsorInfoQuery.data?.guestUserAccess ?? false,
    isLoading: sponsorInfoQuery.isLoading,
    isReady: sponsorInfoQuery.isSuccess,
  }
}
